// Taken from: https://davidwalsh.name/get-promise-status

async function delay<T>(milliseconds = 0, returnValue: T): Promise<T> {
    return new Promise(done => setTimeout(() => done(returnValue), milliseconds));
}

export async function isResolved(promise: Promise<any>): Promise<boolean> {
    return await Promise.race([
        delay(0, false),
        promise.then(
            () => true,
            () => false
        ),
    ]);
}

export async function isRejected(promise: Promise<any>): Promise<boolean> {
    return await Promise.race([
        delay(0, false),
        promise.then(
            () => false,
            () => true
        ),
    ]);
}

export async function isFinished(promise: Promise<any>): Promise<boolean> {
    return await Promise.race([
        delay(0, false),
        promise.then(
            () => true,
            () => true
        ),
    ]);
}
